module.exports = __webpack_public_path__ + "static/media/03.5ddbbfb2.svg";